module.exports = __webpack_public_path__ + "static/media/sumo.833b91be.svg";